import '../daily/DailyPage.css'
import React, {useContext, useEffect, useState} from "react";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import {useUserContext} from "../../../../providers/userProvider/user-context.tsx";
import LeaderBoardUpdatingPage from "../updatingPage/leaderBoardUpdatingPage.tsx";
import useLoading from "../../../../providers/loadingContext/useLoading.ts";
import {VISITOR_LOGIN_LEADERBOARD_TIP} from "../../../../common/constants.ts";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";
import {apiService} from "../../../../common/utils/http/api-service.ts";
import {IAIChallengeRankData, LoginType} from "../../../../common/utils/http/IResponse.ts";
import debounce from "lodash/debounce";
import CustomAvatar from "../../../../components/CustomAvatar/CustomAvatar.tsx";
import Avatar from "../../../../components/Avatar/Avatar.tsx";

type props = {
    isOpen: boolean,
    countryRankingIndex: number,
    openOpponentUserInfoPage: (userId: string) => void;
}

// 每日排行榜
const ChallengeRanking: React.FC<props> = ({isOpen, countryRankingIndex,openOpponentUserInfoPage}) => {
    const {showLoading, hideLoading} = useLoading();
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    const {user} = useUserContext();
    // 排行
    const [rankResult, setRankResult] = useState<IAIChallengeRankData>({
        aiRankList: [],
        myRank: '',
        myLevel: 0
    });

    useEffect(() => {
        if (isOpen) {
            GAEvents.leaderboardPageShow('Challenge_leadboard')
            getRankList();
        }
    }, [isOpen]);

    useEffect(() => {
        getRankList();
    }, [countryRankingIndex]);

    // 获取rank列表
    const getRankList = debounce(async () => {
        try {
            showLoading()
            const response = await apiService.getAiGameRank(countryRankingIndex === 1 ? "" : user?.countryCode)
            if (response.code === 200) {
                setRankResult(response.data);
            }
        } finally {
            hideLoading()
        }
    }, 100);

    return (
        rankResult.aiRankList.length >= 4 ? <div className="daily-ranking-page">
                {/*前三名展示*/}
                <div className="ranking-top-tree-container ">
                    {/*第二名*/}
                    <div className="every-item-container second-item-position game-slide-up-animation-20">
                        {/*头像*/}
                        {/*<img className="second-avatar"*/}
                        {/*     src={rankResult.aiRankList[1]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}*/}
                        {/*     alt="avatar"/>*/}
                        <CustomAvatar onClick={() => openOpponentUserInfoPage(rankResult?.aiRankList[1]?.userId ?? "")}
                                      className="height-50 width-50 margin-bottom-3"
                                      avatar={rankResult?.aiRankList[1]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}
                                      avatarFrame={rankResult?.aiRankList[1]?.avatarFrame}/>
                        {/*昵称*/}
                        <span
                            className="nickname text-center font-size-11 my-roboto-bold">{rankResult.aiRankList[1]?.cgtnName ?? ""} </span>
                        {/*分数*/}
                        <span
                            className="color-blue my-roboto-bold font-size-12">{rankResult.aiRankList[1]?.level ?? ""}</span>
                    </div>
                    {/*第一名*/}
                    <div className="every-item-container first-item-position game-slide-up-animation-20">
                        {/*头像*/}
                        {/*<img className="first-avatar"*/}
                        {/*     src={rankResult.aiRankList[0]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}*/}
                        {/*     alt="avatar"/>*/}
                        <CustomAvatar onClick={() => openOpponentUserInfoPage(rankResult?.aiRankList[0]?.userId ?? "")}
                                      className="height-50 width-50 margin-bottom-3"
                                      avatar={rankResult?.aiRankList[0]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}
                                      avatarFrame={rankResult?.aiRankList[0]?.avatarFrame}/>
                        {/*昵称*/}
                        <span
                            className="nickname text-center font-size-11 my-roboto-bold">{rankResult.aiRankList[0]?.cgtnName ?? ""}</span>
                        {/*分数*/}
                        <span
                            className="color-blue font-size-12 my-roboto-bold">{rankResult.aiRankList[0]?.level ?? ""}</span>
                    </div>
                    {/*第三名*/}
                    <div className="every-item-container third-item-position game-slide-up-animation-20">
                        {/*头像*/}
                        {/*<img className="third-avatar"*/}
                        {/*     src={rankResult.aiRankList[2]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}*/}
                        {/*     alt="avatar"/>*/}
                        <CustomAvatar onClick={() => openOpponentUserInfoPage(rankResult?.aiRankList[2]?.userId ?? "")}
                                      className="height-50 width-50 margin-bottom-3"
                                      avatar={rankResult?.aiRankList[2]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}
                                      avatarFrame={rankResult?.aiRankList[2]?.avatarFrame}/>
                        {/*昵称*/}
                        <span
                            className="nickname text-center font-size-11  my-roboto-bold">{rankResult.aiRankList[2]?.cgtnName ?? ""}</span>
                        {/*分数*/}
                        <span
                            className="color-blue font-size-12 my-roboto-bold">{rankResult.aiRankList[2]?.level ?? ""}</span>
                        {/*勋章*/}
                    </div>
                    {/*勋章*/}
                    <div className="leaderboard-icon-row">
                        <img className="rank-pic-second slide-up-second" src={imgUrls.rankSecondPicUrl} alt="img"/>
                        <img className="rank-pic-third slide-up-third" src={imgUrls.rankThirdPicUrl} alt="img"/>
                        <img className="rank-pic-first slide-up-first" src={imgUrls.rankFirstPicUrl} alt="img"/>

                    </div>
                </div>
                {/*后面排名列表*/}
                <div style={{backgroundImage: `url(${imgUrls.leaderboardListBgUrl})`}}
                     className="width-273 height-220 bg-color-white padding-top-6 position-bottom-46 padding-top-6 margin-left-right-auto border-radius-10 rank-list margin-top-6 display-flex-column position-absolute">
                    <div className="height-210 margin-top-6 overflow-y-auto">
                        {rankResult.aiRankList.map((item, index) => {
                            if (index > 2) {
                                return <div key={item.cgtnName ?? "" + index} className="list-item">
                                    <div className="my-roboto-bold item-margin">{index + 1}</div>
                                    {/*<img className="item-avatar item-margin"*/}
                                    {/*     src={item.cgtnAvatar ?? imgUrls.defaultAvatarUrl}*/}
                                    {/*     alt="avatar"/>*/}
                                    <CustomAvatar onClick={() => openOpponentUserInfoPage(item.userId ?? "")}
                                                  className="height-26 width-26"
                                                  avatar={item?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}
                                                  avatarFrame={item?.avatarFrame}/>
                                    <div
                                        className="my-roboto-regular text-ellipsis item-margin text-left">{item.cgtnName}</div>
                                    <div className="my-roboto-bold item-margin color-blue">{item.level}</div>
                                </div>
                            }
                        })}
                    </div>
                </div>
                {/*底部自己的排行信息*/}
                {user?.loginType === LoginType.CGTN ? <div className="self-container-challenge bg-color-blue">
                        <div className="my-roboto-bold item-margin color-white">{rankResult?.myRank ?? ""}</div>
                        {/*<img className="item-avatar-self item-margin"*/}
                        {/*     src={user.cgtnAvatar ?? imgUrls.defaultAvatarUrl}*/}
                        {/*     alt="avatar"/>*/}
                        <Avatar className="width-26 height-26"/>
                        <div
                            className="my-roboto-bold item-margin text-ellipsis color-white">{user?.cgtnName ?? user?.guestName ?? ""}</div>
                        <div className="my-roboto-bold item-margin color-white">{rankResult?.myLevel ?? ""}</div>
                    </div>
                    :
                    <div className="self-container-guest bg-color-blue font-size-16 my-roboto-medium color-white">
                        {VISITOR_LOGIN_LEADERBOARD_TIP}
                    </div>
                }
            </div>
            : <LeaderBoardUpdatingPage onRefresh={getRankList}/>
    )
}

export default ChallengeRanking